export const UPDATE_WINDOW_SIZE = '@resize/udpate-window-size';
